import React, { useState, useRef, useEffect } from 'react';
import { useScript } from './hooks/useScript';
import jwt_decode from "jwt-decode";
import MyChart from './MyChart';
import MyAccess from './MyAccess';
import MyPaye from './MyPaye';

const App = () => {
  const googlebuttonref = useRef();

  const [user, setUser] = useState(false);
  const [access, setAccess] = useState(false);
  const [paye, setPaye] = useState(false);
  const [authError, setAuthError] = useState(null);
  const [isCheckingAccess, setIsCheckingAccess] = useState(false);
  const [isInAppBrowser, setIsInAppBrowser] = useState(false);

  useEffect(() => {
    try {
      const ua = navigator.userAgent || navigator.vendor || window.opera;
      const inAppPattern = /FBAN|FBAV|Instagram|Line\/|MicroMessenger|Twitter|OkHttp/i;
      if (inAppPattern.test(ua)) {
        setIsInAppBrowser(true);
      }
    } catch (e) {
      // If we can't read the user agent, just ignore
    }
  }, []);

  const onGoogleSignIn = (googleResponse) => {
    setAuthError(null);

    try {
      const userCred = googleResponse.credential;
      const payload = jwt_decode(userCred);
      setUser(payload);
      console.log(payload);

      setIsCheckingAccess(true);
      const hasAccess = MyAccess(payload);
      setAccess(hasAccess);
      if (hasAccess) {
        setPaye(MyPaye);
      } else {
        setPaye(false);
      }
      setIsCheckingAccess(false);
    } catch (err) {
      console.error("Failed to decode Google credential", err);
      setUser(false);
      setAccess(false);
      setPaye(false);
      setIsCheckingAccess(false);
      setAuthError("Impossible de terminer la connexion Google. Réessayez ou ouvrez cette page dans votre navigateur principal (Chrome ou Safari).");
    }
  };

  const handleGoogleScriptError = () => {
    setAuthError("Le script Google n'a pas pu être chargé. Vérifiez votre connexion Internet ou les bloqueurs de contenu, puis réessayez.");
  };

  useScript(
    "https://accounts.google.com/gsi/client",
    () => {
      try {
        if (!window.google || !window.google.accounts || !window.google.accounts.id) {
          setAuthError("Google n'a pas pu être initialisé dans ce navigateur. Essayez d'ouvrir la page dans Chrome ou Safari.");
          return;
        }

        window.google.accounts.id.initialize({
          // For local dev, prefer env var if defined
          // client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID || "793293841566-gvc9e3judu2jqouu3tcplh42h3hg0oq9.apps.googleusercontent.com",
          // For local dev
          // client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
          // For rouge.homeip.net
          client_id: "793293841566-gvc9e3judu2jqouu3tcplh42h3hg0oq9.apps.googleusercontent.com",
          callback: onGoogleSignIn,
          auto_select: false,
        });

        window.google.accounts.id.renderButton(googlebuttonref.current, {
          size: "medium",
          theme: "outline",
          shape: "pill",
          width: 250,
        });
      } catch (e) {
        console.error("Error initializing Google Identity Services", e);
        setAuthError("Une erreur est survenue lors de l'initialisation de Google. Réessayez plus tard.");
      }
    },
    handleGoogleScriptError
  );

  return (
    <div
      align="center"
      className="App"
      style={{
        // display: "flex",
        // justifyContent: "center",
        // alignItems: "center",
        // height: "100vh",
      }}
    >
      {isInAppBrowser && (
        <div
          style={{
            backgroundColor: "#fff3cd",
            color: "#856404",
            border: "1px solid #ffeeba",
            padding: "8px 12px",
            marginBottom: "12px",
            borderRadius: "4px",
            maxWidth: "480px",
          }}
        >
          Google Login peut ne pas fonctionner correctement dans ce navigateur intégré.
          Ouvrez cette page dans votre navigateur principal (Chrome ou Safari) pour une meilleure expérience.
        </div>
      )}

      {!user && <div ref={googlebuttonref}></div>}

      {authError && (
        <p style={{ color: "red", maxWidth: "480px" }}>
          {authError}
        </p>
      )}

      {user && (
        <div align="center">
          {user.name} | {user.email} | {user.sub}
          <p><img src={user.picture} alt="profile" /></p>
          <button
            onClick={() => {
              setUser(false);
              setAccess(false);
              setPaye(false);
              setAuthError(null);
              setIsCheckingAccess(false);
            }}
          >
            Logout
          </button>
        </div>
      )}

      {isCheckingAccess && user && (
        <p>Vérification de l'accès...</p>
      )}

      {!isCheckingAccess && access && user && (
        <p>{user.given_name}, tu as accès</p>
      )}

      {!isCheckingAccess && !access && user && (
        <p>Tu N'as PAS accès</p>
      )}

      {access && (
        <MyChart />
      )}

      {access && (
        <MyPaye />
      )}
    </div>
  );
};

export default App

// from https://www.youtube.com/watch?v=uzvvEgqXUhc&t=611s&ab_channel=ARIS_dev
